import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileAbout} w="95%" alt="Ogenki Sushi About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView row justifyStart alignCenter maxWidth="1100px" m="0 auto">
          <CFImage src={about} w="100%" alt="Ogenki Sushi About" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
